{
  "schema": 1,
  "issuer": "https://auth.iot.creavision.tech/realms/customers",
  "global_api": "https://iot.creavision.tech",
  "regions": [
    {
      "id": "eu1",
      "jurisdiction": "EU",
      "status": "open",
      "api": "https://iot.creavision.tech",
      "web": "https://iot.creavision.tech",
      "ingest": "ingest.iot.creavision.tech",
      "feed": "pub-mqtt.creavision.tech",
      "issuer": "https://auth.iot.creavision.tech/realms/customers",
      "api_version": "0.53.0"
    }
  ]
}
